import React from 'react';
import { Icon } from '@picsio/ui';
import { AddRevisionImport } from '@picsio/icons';
import { string } from 'prop-types';

export default function Placeholder({ text }) {
  return (
    <div className="importAdditionalFieldsPlaceholder">
      <Icon size="xl">
        <AddRevisionImport />
      </Icon>
      <p>{text}</p>
    </div>
  );
}

Placeholder.defaultProps = {
  text: 'Select assets to edit metadata',
};

Placeholder.propTypes = {
  text: string,
};
